module.exports = __webpack_public_path__ + "static/media/promotional-graphic.9fa79ed2.png";